import API from './ks-engine'

const resource = 'db/getassoc';

export default {
  get (params) {
    if (typeof(params) !== "string") {
      const params_array = []
      Object.keys(params).forEach(function (key) {
        if (Array.isArray(params[key])) {
          params[key].forEach(function (val) {
            params_array.push(key+'='+val)
          });
        } else {
          params_array.push(key+'='+params[key])
        }
      });
      params = params_array.join('&')
    }
    return API.get(`/${resource}?${params}`)
  }
}